<div class="flex flex-row justify-end">
  @for (team of Teams; track team) {
    <div class="m-10">
      <button [class]="team.Class" class="text-white font-bold py-2 rounded-full text-2xl px-15" (click)="selectTeam(team.Id);">{{team.TeamName}}</button>
    </div>
  }
</div>
